import styled from 'styled-components';

interface IRootProps {
    widthValue?: string;
    opacityValue?: string;
}

export const Root = styled.div`
    width: 263px;
    width: ${(props: IRootProps) => (props.widthValue ? props.widthValue : 'auto')};
    opacity: ${(props: IRootProps) => (props.opacityValue ? props.opacityValue : 'auto')};
    height: 100%;
    background-color: #FFFFFF;
    overflow-y: auto;
    overflow-x: hidden;
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    &:focus {
        outline-width: 0;
        outline: none;
    }
    
`;

export const SubPicker = styled.div`
    width: 263px;
    width: ${(props: IRootProps) => (props.widthValue ? props.widthValue : 'auto')};
    opacity: ${(props: IRootProps) => (props.opacityValue ? props.opacityValue : 'auto')};
    height: 98%;
    margin: 8px;
    
    border-radius:5px;
    background-color: #FFFFFF;
    overflow-y: auto;
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    
`;



export const RootContainer = styled.div`
    display:flex;
    flex-direction: row;
    height: 100%;
    
`;



